<template>
    <div class="row align-items-end">
        <div class="col-md-2 mb-1 mb-md-0">
            <v-date-picker placeholder="Tarih" v-model="filter.SalaryPaymentDate"></v-date-picker>
        </div>
        <div class="col-md-auto mb-1 mb-md-0">
            <select class="form-control bg-img-none" v-model="branchType">
                <option value="O">Org. Şube</option>
                <option value="S">SGK Şube</option>
            </select>
        </div>
        <div class="col-md-2 mb-1 mb-md-0" v-if="branchType == 'O'">
            <v-select-list :options="branches" label="Name" v-model="branch" placeholder="Tüm Org. Şubeler"></v-select-list>
        </div>
        <div class="col-md-2 mb-1 mb-md-0" v-if="branchType == 'S'">
            <v-select-list :options="sbranches" label="Name" v-model="sbranch" placeholder="Tüm SGK Şubeler"></v-select-list>
        </div>
        <div class="col-md-2 mb-1 mb-md-0">
            <v-select-list :options="collarStatuses" label="Name" v-model="collarStatus" placeholder="Tüm Yakalar"></v-select-list>
        </div>
        <div class="col-md-2 mb-1 mb-md-0">
            <v-select-list :options="statuses" label="Name" v-model="status" placeholder="Durum"></v-select-list>
        </div>
        <div class="col-auto">
            <button class="btn btn-secondary" v-on:click="sendFilter">Filtrele</button>
        </div>
        <div class="col-auto">
            <button class="btn btn-dark" v-on:click="clearForm">Temizle</button>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import SystemDataApi from '@/api/system-data'
import CompanyApi from '@/api/company'

export default {
    data(){
        return {
            filter:{
                Active:null,
                BranchTypeCode:'O',
                BranchId:null,
                CollarStatusId:null,
                Month:null,
                Year:null,
                EmployeeId:null,
                SalaryPaymentDate:null,
            },
            statuses:[
                {Name:"Tümü",Value:null},
                {Name:"Aktif",Value:0},
                {Name:"Bekleme Kuyruğu",Value:1},
                {Name:"Tamamlanan",Value:2},
                {Name:"Reddedilenler",Value:3},
                {Name:"Yanıt Bekleyenler",Value:4},
            ],
            months:[
                {index:1,name:'Ocak'},
                {index:2,name:'Şubat'},
                {index:3,name:'Mart'},
                {index:4,name:'Nisan'},
                {index:5,name:'Mayıs'},
                {index:6,name:'Haziran'},
                {index:7,name:'Temmuz'},
                {index:8,name:'Ağustos'},
                {index:9,name:'Eylül'},
                {index:10,name:'Ekim'},
                {index:11,name:'Kasım'},
                {index:12,name:'Aralık'}
            ],
            branches:[],
            sbranches:[],
            collarStatuses:[],
            branchType:'O',
            branch:null,
            sbranch:null,
            collarStatus:null
        }
    },
    mounted(){
        this.getBranches()
        this.getSBranches()
        this.getCollarStatuses()
    },
    methods:{
        clearForm(){
            this.filter.BranchId = null
            this.filter.BranchTypeCode = 'O'
            this.filter.CollarStatusId = null
            this.filter.Month = null
            this.filter.Year = null
            this.filter.EmployeeId = null
            this.filter.SalaryPaymentDate = null

            this.branchType = 'O'
            this.branch = null
            this.sbranch = null
            this.collarStatus = null

            this.$emit('filter',this.filter)
        },
        sendFilter(){
            this.$emit('filter',{
                Active: this.filter.Active,
                BranchId: this.branchType == 'O' ? (this.branch?.Id || null) : (this.sbranch?.Id || null),
                BranchTypeCode: this.branchType,
                CollarStatusId: this.collarStatus?.Id || null,
                Month: null,
                Year: null,
                SalaryPaymentDate: this.filter.SalaryPaymentDate
            })
        },
        getBranches(){
            CompanyApi.Branch.ListByCode("O").then(res=>{
                this.branches = res.data.Data
            })
        },
        getSBranches(){
            CompanyApi.Branch.ListByCode("S").then(res=>{
                this.sbranches = res.data.Data
            })
        },
        getCollarStatuses(){
            SystemDataApi.CollarStatus().then(res => {
                this.collarStatuses = res.data.Data
            })
        },
    },
    computed:{
        status:{
            get:function(){
                return this.statuses.find(s=>s.Value == this.filter.Active)
            },
            set:function(value){
                this.filter.Active = value?.Value >= 0 ? value?.Value : null
            }
        },
    }
}
</script>